import styled from 'styled-components';

export const StyledBasicDateRangeTimePicker = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;

  .MuiStack-root {
    border: 1px solid var(--color-pale-gray);

    .MuiFormControl-root {
      width: 110px;
    }

    .MuiFormLabel-root {
      display: none !important;
    }

    .MuiFormControl-root {
      margin-left: 0 !important;
    }

    .MuiMultiInputDateRangeField-separator {
      width: 10px !important;
      margin-left: 0 !important;
    }
  }

  .time-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;

    .MuiFormControl-root {
      border: 1px solid var(--color-pale-gray);
    }

    .MuiOutlinedInput-input {
      padding-left: 8px !important;
    }
  }
`;
